<div class="main-container">
  <header class="page-header">
    <div class="title">
      <span class="title-text">Media</span>
      <p class="small-title">Images shared centrally or per establishment. Utsav forms pick their image from here.</p>
    </div>

    <div class="header-actions">
      <input
        type="search"
        class="text-box-active search-box"
        placeholder="Search name, category or establishment"
        aria-label="Search media"
        [formControl]="search"
      />
      @if(canManage){
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="upload()">Upload Media</button>
      }
    </div>
  </header>

  <div class="filter-bar">
    <div class="each-div">
      <label class="drop-title" id="media-scope-label">Scope</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="media-scope-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="scope" (selectionChange)="load()">
          <mat-option [value]="''">All</mat-option>
          <mat-option value="CENTRAL">Central</mat-option>
          <mat-option value="ESTABLISHMENT">Establishment</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div">
      <label class="drop-title" id="media-category-label">Category</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="media-category-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="category" (selectionChange)="load()">
          <mat-option [value]="''">All</mat-option>
          @for(c of categories; track c){ <mat-option [value]="c">{{ c | titlecase }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div">
      <label class="drop-title" id="media-status-label">Status</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="media-status-label" panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="status" (selectionChange)="load()">
          <mat-option value="1">Active</mat-option>
          <mat-option value="0">Inactive</mat-option>
          <mat-option [value]="''">All</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filter-actions">
      <button type="button" class="ac-secondary-btn" [disabled]="isLoading" (click)="reset()">Reset</button>
    </div>
  </div>

  <div class="media-grid">
    @for(item of filteredMedia(); track item.mediaId){
    <article class="media-card" [class.inactive]="!item.isActive">
      <div class="thumb-wrap">
        <img class="thumb" [src]="item.imageUrl" [alt]="item.name" loading="lazy" />
      </div>
      <div class="card-body">
        <span class="media-name" [title]="item.name">{{ item.name }}</span>
        <span class="media-meta">{{ item.category | titlecase }} · {{ placeOf(item) }}</span>
        @if(item.remarks){ <span class="media-remarks" [title]="item.remarks">{{ item.remarks }}</span> }
      </div>
      <div class="card-actions">
        <div class="switch-cell">
          <span class="switch-label">{{ item.isActive ? 'Active' : 'Inactive' }}</span>
          <button
            type="button"
            class="ac-switch"
            role="switch"
            [class.on]="item.isActive"
            [attr.aria-checked]="item.isActive"
            [attr.aria-label]="'Active: ' + item.name"
            [disabled]="isLoading || !canManage"
            (click)="toggleStatus(item)"
          ></button>
        </div>
        @if(canManage){
        <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading" (click)="edit(item)">Edit</button>
        }
      </div>
    </article>
    } @empty {
    @if(!isLoading){
    <p class="empty-note">{{ search.value ? 'No media match the search.' : 'No media yet.' }}</p>
    }
    }
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
